/**
 * 關於我們頁 — 繁體中文（嵌套結構，對應 t('aboutUs.…')，m / pc 共用）
 */
export default {
	meta: {
		breadcrumb: "關於我們",
		title: "關於我們-助你規劃人生、讓生活更輕鬆(See  Beyond)",
		keywords: "先知命局,關於我們,命理平台,八字算命,占卜服務,品牌理念",
		description:
			"先知命局是面向全球用戶的文化內容平台，匯聚全球能人與賢者智慧，整合東方命理、西方占卜、身心靈療癒等學術專業級泰斗，為全球用戶提供精準化、個性化的專業服務。紫微,八字,今日運勢,流年運勢,星座,星盤,桃花,占卜,六爻,手面相,姓名,占星,奇門遁甲,命名,前世,塔羅,點燈,靈符,愛情,姻緣,命盤,農民曆,黃曆,心理測驗,生肖",
		ogTitle: "關於我們-助你規劃人生、讓生活更輕鬆(See  Beyond)",
		ogDescription:
			"紫微,八字,今日運勢,流年運勢,星座,星盤,桃花,占卜,六爻,手面相,姓名,占星,奇門遁甲,命名,前世,塔羅,點燈,靈符,愛情,姻緣,命盤,農民曆,黃曆,心理測驗,生肖",
	},
	hero: {
		ariaLabel: "品牌橫幅",
		slogan: "先知命局，陪你找到人生方向",
	},
	brandPhilosophy: {
		ariaLabel: "品牌理念",
		title: "品牌理念",
		subtitle: "全球人生導師數字平台，助你規劃人生，讓生活更簡單",
		desc: "先知命局（SeerQ）：總部位於香港，全球領先的人生導師數位交易市場，依託 AI 與數位化技術構建 SaaS 平臺，連接有人生抉擇困惑、需隱私化專業幫助的用戶與全球優質導師機構，通過評價體系、擔保服務、標準化流程及高效運營工具，保障雙方權益，陪伴用戶實現自我成長，最終達成讓生活更輕鬆！「See Beyond」的核心願景。平臺以線上線下協同服務為特色，覆蓋全球多區域、多文化場景，致力於成為全球人生成長領域的標杆性數字生態平臺。",
		stats: [
			{ value: "2,000,000+", label: "全球用戶" },
			{ value: "200+", label: "專業導師" },
			{ value: "99%", label: "滿意度" },
		],
	},
	newsRelease: {
		ariaLabel: "新聞發布",
		title: "新聞發布",
		subtitle: "掌握先知命局最新動態，了解我們的發展與里程碑",
		tag: "產品發布",
		viewNewsAria: "查看新聞：{title}",
		paginationAria: "新聞發布分頁",
		prevPage: "上一頁",
		nextPage: "下一頁",
	},
	business: {
		ariaLabel: "商務合作",
		title: "商務合作",
		subtitle: "攜手合作，共創價值",
		offices: [
			{
				title: "香港集團公司",
				contacts: [
					{ icon: "location", text: "香港九龍尖沙咀廣東道海港城海洋中心17樓262室" },
					{ icon: "id", text: "統一社會信用代碼：2003室" },
					{ icon: "phone", text: "電話：+852 2808 1038" },
					{ icon: "mobile", text: "手機：+852 5325 7739" },
					{ icon: "email", text: "電郵：zhanglin{'@'}seerqnet.com" },
				],
			},
			{
				title: "台灣代理營運公司：香港商寶政有限公司台灣分公司",
				contacts: [
					{ icon: "location", text: "台灣台北市大安區信義路四段57號4樓" },
					{ icon: "number", text: "郵遞區號：106" },
					{ icon: "phone", text: "服務電話：+886 979-060-268" },
					{
						icon: "time",
						text: "營業時間：週一至週五 09:00 - 18:00（每週六、日及國定假日公休）",
					},
				],
			},
			{
				title: "馬來西亞分公司",
				contacts: [
					{
						icon: "location",
						text: "Suite A-09-06, Level 9, Menara UOA Bangsar No.5, Jalan Bangsar Utama, 59000 Kuala Lumpur",
					},
					{ icon: "email", text: "電郵：tarry{'@'}seerqnet.com" },
					{ icon: "whatsapp", text: "WhatsApp：+852 5749 8414" },
				],
			},
		],
	},
	cooperativeMedia: {
		ariaLabel: "合作媒體",
		title: "合作媒體",
		subtitle: "攜手優質媒體夥伴，共創價值，傳播影響力",
		groups: [
			{ title: "電視台/廣播電視台", subtitle: "優質電視媒體合作夥伴" },
			{ title: "電視媒體平台", subtitle: "熱門電視媒體平台" },
			{ title: "新媒體全渠道", subtitle: "多元社群媒體合作夥伴" },
			{ title: "報章+網媒", subtitle: "專業新聞媒體夥伴" },
		],
	},
	download: {
		ariaLabel: "下載 App",
		title: "準備開始探索人生方向？",
		desc: "立即下載先知命局App，開啟屬於你的智慧之旅",
		googlePlayAria: "下載 Google Play 版本",
		appStoreAria: "下載 App Store 版本",
		apkAria: "直接下載 APK 文件",
		storeLabel: "Download On The",
		googlePlayName: "Google Play",
		appStoreName: "App Store",
		apkLabel: "下載APK",
		apkName: "Android Apk",
	},
};
